export default "__VITE_ASSET__6631e204__"